<template >
  <div class="deck px-[20px] pt-[10px] pb-[20px] mb-[10px] bg-white rounded-sm">
    <CruiseDetailCommenTitle class="mb-[10px]" :title="title" />
    <div>
      <div class="flex-wrap flex -mr-[9px]">
        <div class="mb-3 w-1/4 pr-[9px]" v-for="item in news" :key="item.no">
          <information-card :report="item" :is-video="isVideo"/>
        </div>
      </div> 
    </div>
  </div>
</template>
<script>
import CruiseDetailCommenTitle from "@/views/company/CruiseDetailCommenTitle.vue"
import InformationCard from "@/views/company/InformationCard.vue";

export default {
  naem: "detailNews",
  components: {
    CruiseDetailCommenTitle,
    InformationCard
  },
  props: {
    news: {
      type: Array,
      default: () => [],
    },
    isVideo:{
      type:Boolean,
      default:false
    },
    title:{
      type:String,
      default:""
    }
  },
};
</script>
<style lang="scss" scoped>


</style>